@use '../../../../app/styles/common/mixins';

.deliveryWrapper {
  display: flex;
  flex-direction: row;
  gap: 4px;

  @include mixins.tablet {
    gap: 8px;
  }
}

.deliveryMap {
  border-radius: var(--rounding16);
  flex: 1;
  overflow: hidden;
}

.mapPlaceholder {
  background-color: var(--bg-tonal-neutral);
}

.deliveryDescription {
  display: flex;
  align-items: center;
  margin-top: var(--spasing16);

  @include mixins.body-primary-400;
}

.descriptionIcon {
  margin-right: 12px;
  width: 40px;
  height: 40px;
}

.deliveryText {
  display: flex;
  align-self: stretch;
  flex-direction: column;
  justify-content: space-between;
}

.deliveryTitle {
  color: var(--fg-secondary);
  line-height: 1.2 !important;
}

.deliveryButton {
  margin-top: var(--spasing16);
}
